import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  AppContext,
  RoundUserContext,
  ValueContext,
} from "../../../../../context/createContext";
import {
  LiveScoreColumnContainer,
  LiveScoreColumnHeader,
} from "./liveScoresComponentsStyles/LiveScoresColumnStyles";

import LiveScoresColumn from "./liveScoresComponentHelpers/LiveScoresColumn";
import { useTranslation } from "../../../../../locale/context";

const userI = [-1, -2];

const LiveScoresLiveColumn = () => {
  const {
    auth: { player_id, player_name },
    config,
    // jackpot,
  } = useContext(AppContext);

  const {
    roundupdate: { state },
  } = useContext(ValueContext);
  const roundUserUpdates = useContext(RoundUserContext);

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      user: t("common.liveBet.table.user"),
      bet: t("common.liveBet.table.bet"),
      mult: t("common.liveBet.table.mult"),
      win: t("common.liveBet.table.win"),
    };
  }, [t]);

  const [roundUpdate, setRoundUpdate] = useState<any[]>([]);
  const [userRound, setUserRound] = useState<any[]>([]);

  useEffect(() => {
    let userRounds: any[] = [];
    let othersRounds: any[] = [];
    roundUserUpdates.forEach((rounds) => {
      if (
        rounds.id === player_id &&
        rounds.index !== "" &&
        rounds.cashout === 0
      ) {
        userRounds = [{ ...rounds, name: player_name }, ...userRounds];
      }
      if (
        rounds.id !== player_id &&
        rounds.index !== "" &&
        rounds.cashout === 0
      ) {
        othersRounds = [rounds, ...othersRounds];
      }
    });
    roundUserUpdates.forEach((rounds) => {
      if (
        rounds.id === player_id &&
        rounds.index !== "" &&
        rounds.cashout > 0
      ) {
        userRounds = userRounds.map((round) =>
          round.index === rounds.index
            ? { ...rounds, name: player_name }
            : round
        );
      }
      if (
        rounds.id !== player_id &&
        rounds.index !== "" &&
        rounds.cashout > 0
      ) {
        othersRounds = othersRounds.map((round) =>
          round.index === rounds.index && round.id === rounds.id
            ? rounds
            : round
        );
      }
    });
    setRoundUpdate(othersRounds);
    setUserRound(userRounds);
  }, [roundUserUpdates]);

  const clearRounds = () => {
    setRoundUpdate([]);
    setUserRound([]);
  };

  useEffect(() => {
    state === 3 && clearRounds();
  }, [state]);

  return (
    <LiveScoreColumnContainer>
      <LiveScoreColumnHeader>
        <h1>{languagePack.user}</h1>
        <h1>{languagePack.bet}</h1>
        <h1>{languagePack.mult}</h1>
        <h1>{languagePack.win}</h1>
      </LiveScoreColumnHeader>
      {userRound.map((round, i) => (
        <LiveScoresColumn
          eachUser={round}
          key={userI[i]}
          i={userI[i]}
          prec={config.prec}
        ></LiveScoresColumn>
      ))}
      {roundUpdate.map(
        (eachUser, i) =>
          eachUser.bet !== 0 && (
            <LiveScoresColumn
              eachUser={eachUser}
              i={i}
              roundUpdate={roundUpdate.length}
              key={i}
              prec={config.prec}
            ></LiveScoresColumn>
          )
      )}
    </LiveScoreColumnContainer>
  );
};

export default LiveScoresLiveColumn;
